module.exports = "## Flat Button\n\n[Flat Buttons](https://www.google.com/design/spec/components/buttons.html#buttons-flat-raised-buttons)\nare used for general functions and reduce the amount of layering on the screen,\nmaking it more readable.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/FlatButton/README.md
 ** module id = 986
 ** module chunks = 0
 **/